import { mapState } from 'vuex';
export default {
  name: 'ContainerWithLabel',
  props: {
    label: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState('app', ['color', 'UiTheme'])
  },
  methods: {}
};